import { Component, ErrorInfo } from 'react';
import { getBotpress } from '../modules/botpress/Botpress';
import { captureError } from './datadog';

export interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export interface ErrorBoundaryState {
  hasError?: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    captureError(error, 'ErrorBoundary', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      void getBotpress().then((botpress) => {
        botpress.open();
      });
    }

    return this.props.children;
  }
}
